import { render, staticRenderFns } from "./UserPolicy.vue?vue&type=template&id=c5753cfa&scoped=true&"
import script from "./UserPolicy.vue?vue&type=script&lang=js&"
export * from "./UserPolicy.vue?vue&type=script&lang=js&"
import style0 from "./UserPolicy.vue?vue&type=style&index=0&id=c5753cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5753cfa",
  null
  
)

export default component.exports